import { createI18n as createVueI18n } from 'vue-i18n'

let _locale = 'ja';
let _messages = {};

export const initI18n = (locale, messages, localizer) => {
  if (localizer) {
    let resources = {};
    localizer.forEach((res) => {
      resources[res.name] = res.value;
    });
    messages[locale].resources = resources;
  }
  _locale = locale;
  _messages = messages;
};
export const createI18n = (locale, messages) => {
  const i18n = createVueI18n({
    locale: _locale,
    messages: _messages
  });
  return i18n;
};
